import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { ContactForm } from '../components/ContactForm';
import { usePageMeta } from '../hooks/usePageMeta';
import { PHONE_DISPLAY, PHONE_HREF, trackCallConversion } from '../utils/phone';
import { SERVICE_AREA_CITIES } from '../utils/seo';
export function ContactPage() {
  usePageMeta({
    title: "Contact & Get a Quote | Mike's Pro Detail",
    description: "Request a free mobile detailing quote from Mike's Pro Detail, or call or text 818-381-9905. Serving Camarillo, Ventura, Thousand Oaks and all of Ventura County.",
    path: '/contact',
    breadcrumbName: 'Contact'
  });
  return <main data-id="element-699" data-mp="f0fo5dceq90r">
      <PageHeader breadcrumb="Contact" title="Contact Mike's Pro Detail" subtitle="Call or text for the fastest answer, or send a quote request and Mike will get back to you shortly." showCta={false} data-id="element-700" data-mp="f05zbt33m7wn" />

      <section className="w-full bg-black py-16 px-4" data-id="element-701" data-mp="1qg4co95b7g3o">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-14 items-start" data-id="element-702" data-mp="r0yaihajlq7q">
          <div className="space-y-10" data-id="element-703" data-mp="n0eg3lhct0pa">
            <a href={PHONE_HREF} onClick={trackCallConversion} className="block p-6 sm:p-8 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-colors duration-150" aria-label={`Call or text Mike's Pro Detail at ${PHONE_DISPLAY}`} data-id="element-704" data-mp="mx8o9yhcbkpv">
              <span className="block text-sm uppercase tracking-widest text-gray-400 font-bold" data-id="element-705" data-mp="82m2iyvdamdq">
                Call or Text
              </span>
              <span className="mt-2 flex items-center gap-3" data-id="element-706" data-mp="3vewjvb09hu33">
                <Phone className="w-7 h-7 shrink-0 text-red-500" aria-hidden="true" data-id="element-707" data-mp="3vfeqn1kjvqp9" />
                <span className="text-3xl sm:text-4xl font-black text-white tracking-tight whitespace-nowrap" data-id="element-708" data-mp="3qh3bqcfeeq06">
                  {PHONE_DISPLAY}
                </span>
              </span>
              <span className="mt-3 block text-gray-400" data-id="element-709" data-mp="3ginmyg3ufstu">
                Tap to call on mobile.
              </span>
            </a>

            <div data-id="element-710" data-mp="36sp5h74yilbi">
              <h2 className="text-xl font-black uppercase text-white" data-id="element-711" data-mp="36wcubszgijjw">
                Service Area
              </h2>
              <p className="mt-2 text-gray-400 leading-relaxed" data-id="element-712" data-mp="2xtllm0xyu1vy">
                We're fully mobile and come to you throughout Ventura County and
                select surrounding areas.
              </p>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-713" data-mp="3pjzt9ffdyhz6">
                {SERVICE_AREA_CITIES.map(city => <li key={city} data-id="element-714" data-mp="3ujuhtcbouvh2">
                    <Link to={city === 'Thousand Oaks' ? '/mobile-detailing-thousand-oaks' : `/service-areas/${city.toLowerCase().replace(/\s+/g, '-')}`} className="inline-flex items-center gap-2 text-gray-300 hover:text-yellow-400 transition-colors duration-150" data-id="element-715" data-mp="3uj2zv4b0kw99">
                      <MapPin className="w-4 h-4 text-red-500 shrink-0" aria-hidden="true" data-id="element-716" data-mp="cdpvt6i0z2r0" />
                      {city}
                    </Link>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-717" data-mp="21u1xnix1aq3n">
              <h2 className="text-xl font-black uppercase text-white" data-id="element-718" data-mp="21tir0ycu3o4x">
                What We Need From You
              </h2>
              <p className="mt-2 text-gray-400 leading-relaxed" data-id="element-719" data-mp="1wtxoyf2daznz">
                We bring our own water and detailing equipment. We require
                access to a standard electrical outlet at the service location.
              </p>
              <Link to="/faq" className="mt-3 inline-block text-yellow-400 font-bold hover:text-yellow-300 transition-colors duration-150" data-id="element-720" data-mp="1ivpqg2ponqap">
                More answers in our FAQ &rarr;
              </Link>
            </div>
          </div>

          <ContactForm data-id="element-721" data-mp="1svqajqvdmafy" />
        </div>
      </section>
    </main>;
}